import { Rights } from '@dokucoach/common-types';
import { useContextAuthManager } from 'components/AuthManager';
import PrivateRoute from 'components/AuthManager/PrivateRoute';
import PermissionError from 'components/PermissionError';
import routePaths from 'constants/route-paths';
import FreeBedsList from 'pages/Lists/FreeBeds';
import OccupancyIndicator from 'pages/Lists/OccupancyIndicator';
import React from 'react';
import { getRoute } from 'utils/path';

const BaseDataListGeneral = React.lazy(() => import('pages/Lists/BaseDataGeneralList'));
const BaseDataKvList = React.lazy(() => import('pages/Lists/BaseDataKvList'));
const BaseDataListReferenceCare = React.lazy(() => import('pages/Lists/BaseDataReferenceCareList'));
const ConsultingListGeneral = React.lazy(() => import('pages/Lists/ConsultingGeneralList'));
const MedicationList = React.lazy(() => import('pages/Lists/MedicationList'));
const MedicationOrdersList = React.lazy(() => import('pages/Lists/MedicationOrders'));
const VisitSheetQuestions = React.lazy(() => import('pages/Lists/VisitSheetQuestions'));
const NursingOverview = React.lazy(() => import('pages/Lists/NursingOverview'));
const RiskGroups = React.lazy(() => import('pages/Lists/RiskGroups'));
const RiskList = React.lazy(() => import('pages/Lists/RiskList'));
const EmployeeBaseDataGeneral = React.lazy(() => import('pages/Lists/EmployeeBaseDataGeneralList'));
const ExternalInformation = React.lazy(() => import('pages/Lists/ExternalInformationList'));

export const ListRoutes = () => {
  const { hasOnePermission } = useContextAuthManager();
  return (
    <>
      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_MEDICATION])}
        component={() =>
          hasOnePermission([Rights.LISTS.MEDICATION, Rights.LISTS.READ]) ? (
            <MedicationList />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_NURSING_OVERVIEW])}
        component={() =>
          hasOnePermission([Rights.LISTS.NURSING_OVERVIEW, Rights.LISTS.READ]) ? (
            <NursingOverview />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_RISK_GROUPS])}
        component={() =>
          hasOnePermission([Rights.LISTS.RISK_GROUPS, Rights.LISTS.READ]) ? (
            <RiskGroups />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_RISK_LIST])}
        component={() =>
          hasOnePermission([Rights.LISTS.RISK_LIST, Rights.LISTS.READ]) ? (
            <RiskList />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_BASE_DATA_GENERAL])}
        component={() =>
          hasOnePermission([Rights.LISTS.BASE_DATA_GENERAL, Rights.LISTS.READ]) ? (
            <BaseDataListGeneral />
          ) : (
            <PermissionError />
          )
        }
      />
      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_EMPLOYEE_BASE_DATA_GENERAL])}
        component={() =>
          hasOnePermission([Rights.LISTS.EMPLOYEE_BASE_DATA_GENERAL, Rights.LISTS.READ]) ? (
            <EmployeeBaseDataGeneral />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_BASE_DATA_REFERENCE_CARE])}
        component={() =>
          hasOnePermission([Rights.LISTS.BASE_DATA_REFERENCE_CARE, Rights.LISTS.READ]) ? (
            <BaseDataListReferenceCare />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_BASE_DATA_CONSULTING])}
        component={() =>
          hasOnePermission([Rights.LISTS.BASE_DATA_CONSULTING, Rights.LISTS.READ]) ? (
            <ConsultingListGeneral />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_EXTERNAL_INFORMATION])}
        component={() =>
          hasOnePermission([Rights.LISTS.EXTERNAL_INFORMATION, Rights.LISTS.READ]) ? (
            <ExternalInformation />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_BASE_DATA_KV])}
        component={() =>
          hasOnePermission([Rights.LISTS.BASE_DATA_KV, Rights.LISTS.READ]) ? (
            <BaseDataKvList />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_VISIT_SHEET_QUESTIONS])}
        component={() =>
          hasOnePermission([Rights.LISTS.VISIT_SHEET_QUESTIONS, Rights.LISTS.READ]) ? (
            <VisitSheetQuestions />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_MEDICATION_ORDERS])}
        component={() =>
          hasOnePermission([Rights.CARE.MEDICATION_ORDER.READ, Rights.LISTS.READ]) ? (
            <MedicationOrdersList />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_FREE_BEDS])}
        component={() =>
          hasOnePermission([
            Rights.ADMINISTRATION_AND_INVOICING.ADMINISTRATE.READ,
            Rights.LISTS.READ,
          ]) ? (
            <FreeBedsList />
          ) : (
            <PermissionError />
          )
        }
      />

      <PrivateRoute
        exact
        path={getRoute([routePaths.LISTS_OCCUPANCY_INDICATOR])}
        component={() =>
          hasOnePermission([
            Rights.ADMINISTRATION_AND_INVOICING.ADMINISTRATE.READ,
            Rights.LISTS.READ,
          ]) ? (
            <OccupancyIndicator />
          ) : (
            <PermissionError />
          )
        }
      />
    </>
  );
};
